import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: BASE,
  withCredentials: true, // for httpOnly session cookie
});

// Also send Bearer token if we have one in memory (fallback for browsers blocking 3rd-party cookies)
let inMemoryToken = null;

export function setAuthToken(t) {
  inMemoryToken = t;
  if (t) {
    localStorage.setItem("splink_token", t);
  } else {
    localStorage.removeItem("splink_token");
  }
}

export function getAuthToken() {
  return inMemoryToken || localStorage.getItem("splink_token");
}

api.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const API_BASE = BASE;
